// A photo's purpose and caption, under it in the full-screen view (DATAVERSE.md
// 22 Oct): what the photo is evidence of, and the words the report prints
// under it. Saved on the photo's row like any edit, offline too. The feature
// photo's purpose is "Feature photo" (★ on the Measure tab), so it has none to choose.
import { patchFields } from '../lib/device-db';
import { CHOOSABLE_PURPOSES } from '../lib/photo-rows';
import type { ShownPhoto } from '../lib/area-photos';
import { EvidencePointButton } from './evidence-point-button';
import { SavedTextField } from './saved-text-field';

/** The API's limit (photo-table.ts). */
const CAPTION_MAX = 500;

export function PhotoDetails({ photo }: { photo: ShownPhoto & { row: NonNullable<ShownPhoto['row']> } }) {
  const { row } = photo;
  const purpose = typeof row.fields.hig_purpose === 'string' ? row.fields.hig_purpose : null;
  return (
    <div className="w-full max-w-3xl space-y-2 rounded-lg bg-white/95 px-4 py-3 text-sm text-slate-900 shadow">
      {!photo.areaPhoto && (
        <div className="flex flex-wrap items-center gap-2" role="group" aria-label="Purpose">
          <span className="text-xs text-slate-500">Purpose</span>
          {CHOOSABLE_PURPOSES.map((p) => (
            <button
              key={p}
              type="button"
              aria-pressed={purpose === p}
              onClick={() => void patchFields(row.id, { hig_purpose: purpose === p ? null : p })}
              className={`min-h-11 rounded-full border px-3 ${purpose === p ? 'border-primary bg-primary text-primary-foreground' : 'border-slate-300 text-slate-700'}`}
            >
              {p}
            </button>
          ))}
        </div>
      )}
      <SavedTextField
        id={`photo-caption-${photo.id}`}
        label="Caption"
        value={typeof row.fields.hig_caption === 'string' ? row.fields.hig_caption : ''}
        onSave={(caption) => patchFields(row.id, { hig_caption: caption.trim() || null })}
        placeholder="Caption for the report (left blank, the photo's name)"
        maxLength={CAPTION_MAX}
      />
      {/* On a condition visit: keep this view for later visits to retake (evidence-point-button.tsx). */}
      {typeof row.fields.hig_sitevisitid === 'string' && <EvidencePointButton row={row} />}
    </div>
  );
}
